import React, { useState, useEffect } from "react";
import ArticleHeader from "../components/ArticleHeader/ArticleHeader";
import Container from "../components/Container/Container";
import Intro from "../components/Intro/Intro";
import PatternBackground from "../components/PatternBackground/PatternBackground";
import Spacer from "../components/Spacer/Spacer";
import Editorial from "../components/Editorial/Editorial";
import { RouteComponentProps } from "react-router-dom";
import { getArticle, Article as ArticleModel } from "../api/cocApi";

export interface Props extends RouteComponentProps<{ slug?: string }> {}

function Article(props: Props) {
    const [article, setArticle] = useState<ArticleModel>();

    useEffect(() => {
        if (props.match.params.slug) {
            getArticle("/" + props.match.params.slug).then(c => setArticle(c));
        }
    }, [props.match.params.slug]);

    if (article == null) {
        return null;
    }

    return (
        <>
            <ArticleHeader
                heading={article.heading}
                image={process.env.PUBLIC_URL + "/assets/Business_Sweden_logo_white.svg"}
                imageHeight={60}
                preHeading={article.preHeading}
            />

            {article.introduction ? (
                <PatternBackground>
                    <Container>
                        <Intro content={article.introduction} />
                    </Container>
                </PatternBackground>
            ) : null}

            <Container>
                <Spacer size="Spacer--medium">
                    <Editorial>
                        <div dangerouslySetInnerHTML={{ __html: article.body }}></div>
                    </Editorial>
                </Spacer>
            </Container>
        </>
    );
}

export default Article;
